import { useEffect, useRef, useState } from 'react';

import {
  IconButton,
  Box,
  List,
  alpha,
  ListItem,
  Divider,
  Typography,
  ListItemText,
  Popover,
  Tooltip,
  styled
} from '@mui/material';
import Text from 'src/components/Text';

import WarningTwoToneIcon from '@mui/icons-material/WarningTwoTone';

import { US } from 'country-flag-icons/react/3x2';
import { RU } from 'country-flag-icons/react/3x2';
import { RO } from 'country-flag-icons/react/3x2';
import React from 'react';
import useAuth from "src/hooks/useAuth";
import internationalization from "../../../../../core/i18n/i18n"
import { useTranslation } from 'react-i18next';
const SectionHeading = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
        padding: ${theme.spacing(2, 2, 0)};
`
);

const IconButtonPrimary = styled(IconButton)(
  ({ theme }) => `
    margin-left: ${theme.spacing(1)};
    background: ${theme.colors.alpha.trueWhite[10]};
    color: ${theme.colors.alpha.trueWhite[70]};
    padding: 0;
    width: 42px;
    height: 42px;
    border-radius: 100%;
    transition: ${theme.transitions.create(['background', 'color'])};

    svg {
      width: 26px;
    }

    &.active,
    &:active,
    &:hover {
      background: ${alpha(theme.colors.alpha.trueWhite[30], 0.2)};
      color: ${theme.colors.alpha.trueWhite[100]};
    }
`
);

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const { t }: { t: any } = useTranslation();
  const getLanguage = i18n.language;

  useEffect(() => {
    if(internationalization.language != "ro" && internationalization.language != "ru") {
      internationalization.changeLanguage("ro");
    }
  },[])

  const switchLanguage = ({ lng }: { lng: any }) => {
    internationalization.changeLanguage(lng);
  };
  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip arrow title={t('Language Switcher')}>
        <IconButtonPrimary color="primary" ref={ref} onClick={handleOpen}>
        {internationalization.language === 'ro' && <RO title="Romanian" />}
          {internationalization.language === 'ru' && <RU title="Russian" />}
        </IconButtonPrimary>
      </Tooltip>
      <Popover
        disableScrollLock
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <Box
          sx={{
            maxWidth: 240
          }}
        >
          <SectionHeading variant="body2" color="text.primary">
            {t('Language Switcher')}
          </SectionHeading>
          <List
            sx={{
              p: 2,
              svg: {
                width: 26,
                mr: 1
              }
            }}
            component="nav"
          >
               <ListItem
              className={
                getLanguage === 'ro' || getLanguage === 'ro-RO' ? 'active' : ''
              }
              button
              onClick={() => {
                switchLanguage({ lng: 'ro' });
                handleClose();
              }}
            >
              <RO title="Romanian" />
              <ListItemText
                sx={{
                  pl: 1
                }}
                primary="Romanian"
              />
            </ListItem>
            <ListItem
              className={
                getLanguage === 'ru' || getLanguage === 'ru-RU' ? 'active' : ''
              }
              button
              onClick={() => {
                switchLanguage({ lng: 'ru' });
                handleClose();
              }}
            >
              <RU title="Russian" />
              <ListItemText
                sx={{
                  pl: 1
                }}
                primary="Russian"
              />
            </ListItem>
            {/* <ListItem
              className={
                getLanguage === 'en' || getLanguage === 'en-US' ? 'active' : ''
              }
              button
              onClick={() => {
                switchLanguage({ lng: 'en' });
                handleClose();
              }}
            >
              <US title="English" />
              <ListItemText
                sx={{
                  pl: 1
                }}
                primary="English"
              />
            </ListItem>
          */}
          </List>
        </Box>
      </Popover>
    </>
  );
}

export default LanguageSwitcher;
